import _ from 'lodash'
import i18n from './i18n.json'
import browser from '../../../multipay/services/browser'
import css from 'raw-loader!./button.css.raw'

export default class Button {
  constructor (multipay) {
    this.multipay = multipay
    this.handlers = {}
  }

  render () {
    _.each(document.querySelectorAll('.komoju-button'), (el) => this._render(el))
  }

  _render (el) {
    let config = {}

    // Clone HTMLNode dataset to object
    _.forEach(el.dataset, (value, key) => {
      config[key] = value
    })

    let handler = this.multipay.configure({
      key: config.key,
      token: (token) => {
        let input = document.createElement('input')
        input.setAttribute('type', 'hidden')
        input.setAttribute('name', 'token')
        input.setAttribute('value', token.id)
        el.parentNode.insertBefore(input, el)
        el.parentNode.submit()
      }
    })

    this._injectStyle()

    let button = document.createElement('button')
    button.innerHTML = this._defaultLabel(config)
    button.setAttribute('type', 'button')
    button.setAttribute('class', 'komoju-button-el')
    button.addEventListener('click', (e) => handler.open(config))

    el.parentNode.insertBefore(button, el)

    this.handlers[handler.uuid] = handler
  }

  _injectStyle () {
    let head = document.head || document.getElementsByTagName('head')[0]
    let style = document.createElement('style')
    style.type = 'text/css'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
  }

  _defaultLabel (config) {
    let locale = config.locale || browser.browserLocale()
    return i18n[locale]['defaultLabel']
  }
}



// WEBPACK FOOTER //
// ./src/api/components/button/index.js